// Products data — accurate info provided by Herbs We Love
// Products with variants use a `variants` array (label + price + optional compareAtPrice)

export const products = [
  {
    id: 'a-okay-elixir',
    title: 'A-OKAY Elixir',
    price: 10.00,
    compareAtPrice: 14.99,
    images: [
      '/images/products/a-okay-elixir.jpg'
    ],
    category: 'Elixirs',
    tags: ['CBD', 'Calm', 'Anxiety'],
    tagline: 'Quick relief for anxiety or panic',
    description: 'A-OKAY Elixir is a versatile alternative health product designed to promote wellness and balance by calming the nervous system and supporting stress relief, infused with nano CBD and adaptogenic herbs. Experience revitalizing effects with this convenient, easy-to-use dropper for daily support. No THC, no high \u2014 just grounded wellness.',
    benefits: [
      'Nano CBD & Peppermint Oil: fast-acting and soothing',
      'Chamomile, Valerian, Kava: natural sedatives',
      'Ashwagandha: calms cortisol and emotional tension'
    ],
    size: '5ml \u2014 50mg CBD per bottle',
    ingredients: 'Water, Glycerin, Chamomile, Ashwagandha, Kava, Valerian, Coconut Oil, CBD, Nano CBD & Peppermint Oil.',
    note: 'Please note that the 5ml travel size DOES NOT have ingredient labels and the colors of the bottles may vary.',
    howToUse: 'Shake well. Place 1 dropper under the tongue as needed, up to 2 times daily.'
  },
  {
    id: 'boost-elixir',
    title: 'Boost Elixir',
    price: 10.00,
    compareAtPrice: 15.99,
    images: [
      '/images/products/boost-elixir.jpg',
      'https://www.herbswelove.com/cdn/shop/files/boostelixir.jpg?v=1764487678&width=1200'
    ],
    category: 'Elixirs',
    tags: ['CBD', 'Immune'],
    tagline: 'Immune Health \u2014 5ml Travel Size',
    description: 'CBD-Infused Wellness Drops for Immune Support. Support your body\u2019s natural defenses with this compact, travel-friendly immune blend. Infused with CBD Isolate and Nano CBD, this formula combines traditional botanicals and modern wellness ingredients to help you stay balanced on the go.',
    benefits: [
      '5ml travel size \u2014 perfect for pockets, purses, or daily carry',
      'CBD Isolate + Nano CBD for fast-absorbing support',
      'Includes elderberry, ginger, cinnamon, echinacea, and reishi',
      'Glycerin-based formula with colloidal silver and vitamin C',
      'Designed to complement your wellness routine'
    ],
    size: '5ml travel size',
    ingredients: 'Glycerin, Water, Colloidal Silver, Elderberry, Vitamin C, Lecithin, Coconut Oil, Ginger, Cinnamon, Ashwagandha, Echinacea, Reishi, CBD Isolate, Nano CBD.',
    note: 'Travel-size bottles do not include ingredient labels. Bottle color may vary.',
    howToUse: 'Shake well. Take 1 dropper daily or as needed for immune support.'
  },
  {
    id: 'calming-pet-drops',
    title: 'Calming Pet Drops',
    price: 10.00,
    compareAtPrice: 15.99,
    images: [
      '/images/products/calming-pet-drops.jpg',
      'https://www.herbswelove.com/cdn/shop/files/How_to_use_pet_drops.png?v=1764459370&width=1200',
      'https://www.herbswelove.com/cdn/shop/files/Pets_drops_guide.png?v=1764459418&width=1200'
    ],
    category: 'Pets',
    tags: ['Pets', 'CBD', 'Calming'],
    tagline: 'Vegan Oral Supplement for Pet Wellness & Calm',
    description: 'Support your pet\u2019s comfort with this gentle, plant-based CBD formula designed for dogs, cats, birds, reptiles, and small mammals. Whether your companion is aging, recovering, or experiencing stress, these drops offer a simple way to promote daily calm and well-being.',
    benefits: [
      '11mg CBD per dropper for easy, consistent dosing',
      'CBD Isolate + MCT Coconut Oil \u2014 vegan, THC-free, all-natural',
      'Suitable for furry, feathered, or scaly friends',
      'May support relaxation, restfulness, and overall comfort',
      'Veterinarian-guided use recommended for best results'
    ],
    variants: [
      { id: '350-5', label: '350mg CBD (5 ml)', price: 10.00 },
      { id: '350-30', label: '350mg CBD (30 ml)', price: 25.00 },
      { id: '1000-30', label: '1000mg CBD (30 ml)', price: 45.00 }
    ],
    size: 'Choose 5 ml or 30 ml',
    ingredients: 'MCT Coconut Oil, CBD Isolate.',
    howToUse: 'Shake well. Administer directly or mix into food. Start low and observe.'
  },
  {
    id: 'cbd-lip-quench-collection',
    title: 'CBD Lip Quench Collection',
    price: 9.00,
    compareAtPrice: 15.00,
    images: [
      '/images/products/cbd-lip-quench-collection.jpg',
      'https://www.herbswelove.com/cdn/shop/files/coconut_peppermint_lip_balm.jpg?v=1764490270&width=1200',
      'https://www.herbswelove.com/cdn/shop/files/coconut_lip.jpg?v=1764490246&width=1200',
      'https://www.herbswelove.com/cdn/shop/files/cherry_vanilla_lip_balm.jpg?v=1764490246&width=1200'
    ],
    category: 'Skincare',
    tags: ['Lip Care', 'CBD'],
    tagline: 'Nano CBD Topicals \u2014 50mg CBD each',
    description: 'Nourish, hydrate, and soften your lips with our Lip Quench Collection. Infused with Nano CBD and crafted with rich botanical oils, each balm uses liposome technology to penetrate deeply, restoring moisture and leaving lips kissably soft \u2014 never sticky.',
    benefits: [
      '50mg Nano CBD per balm',
      'Liposome molecules for deep hydration',
      'Non-sticky, nourishing formula',
      'Crafted with beeswax, coconut oil, almond oil, hemp seed oil, shea butter, and vitamin E',
      'Enhanced with natural botanicals and essential oils'
    ],
    variants: [
      { id: 'cherry-vanilla', label: 'Cherry Vanilla (Tinted)', price: 9.00 },
      { id: 'natural-berry', label: 'Natural Berry', price: 9.00 },
      { id: 'peppermint', label: 'Peppermint', price: 9.00 },
      { id: 'coconut', label: 'Coconut', price: 9.00 },
      { id: 'all-4-pack', label: 'All 4 Flavors Bundle', price: 30.00, compareAtPrice: 36.00 }
    ],
    ingredients: 'Coconut Oil, Beeswax, Almond Oil, Mango Oil, Shea Butter/Olein, Castor Oil, Hemp Seed Oil, Squalane/Squalene Oil, Vitamin E, Nano CBD Oil, Natural Flavor/Essential Oils (Peppermint, Vanilla, Berry, Raspberry, etc.). Ingredients vary slightly by flavor.',
    howToUse: 'Apply generously to lips as often as desired.'
  },
  {
    id: 'cherry-vanilla-lip-balm',
    title: 'Cherry Vanilla Lip Balm',
    price: 9.00,
    compareAtPrice: 15.00,
    images: [
      '/images/products/cherry-vanilla-lip-balm.jpg'
    ],
    category: 'Skincare',
    tags: ['Lip Care', 'CBD'],
    tagline: 'Tinted Nano CBD Lip Balm \u2014 50mg CBD',
    description: 'A sweet, tinted lip balm with cherry and vanilla notes infused with 50mg of Nano CBD. Liposome technology delivers deep hydration for kissably soft lips \u2014 never sticky.',
    benefits: [
      '50mg Nano CBD per balm',
      'Subtle natural tint',
      'Deeply hydrating and non-sticky',
      'Cherry-vanilla flavor'
    ],
    ingredients: 'Coconut Oil, Beeswax, Almond Oil, Shea Butter, Castor Oil, Hemp Seed Oil, Vitamin E, Nano CBD Oil, Natural Cherry & Vanilla Flavor.',
    howToUse: 'Apply generously to lips whenever they need a soft moment.'
  },
  {
    id: 'coconut-vanilla-sugar-body-scrub',
    title: 'Coconut & Vanilla Sugar Body Scrub',
    price: 13.99,
    compareAtPrice: 19.99,
    images: [
      '/images/products/coconut-vanilla-scrub.jpg',
      '/images/products/scrub-how-to-use.png'
    ],
    category: 'Skincare',
    tags: ['Body Scrub', 'Nano CBD'],
    tagline: 'Nano CBD Sugar Body Scrub \u2014 2oz',
    description: 'Exfoliate and renew with this calming scrub, crafted with high-quality sugar, nourishing oils, and CBD isolate. Leaves your skin soft, radiant, and refreshed \u2014 without any psychoactive effects.',
    benefits: [
      'Gentle exfoliation with cane sugar',
      'Nourishing coconut, grapeseed, olive & hemp seed oils',
      'Infused with Nano CBD isolate',
      'Silky, tropical scent'
    ],
    size: '2 oz',
    ingredients: 'Sugar, Sunflower Oil, Coconut Oil, Grape Seed Oil, Olive Oil, Nano CBD, Citric Acid, Coconut Flakes, Hemp Seed Oil, Vitamin E, Vanilla EO.',
    howToUse: 'Massage onto damp skin in circular motions. Rinse thoroughly. Use 2\u20133 times a week.'
  },
  {
    id: 'lavender-eucalyptus-sugar-body-scrub',
    title: 'Lavender & Eucalyptus Sugar Body Scrub',
    price: 13.99,
    compareAtPrice: 19.99,
    images: [
      '/images/products/lavender-eucalyptus-scrub.jpg',
      '/images/products/scrub-how-to-use.png'
    ],
    category: 'Skincare',
    tags: ['Body Scrub', 'Nano CBD', 'Relaxing'],
    tagline: 'Nano CBD Sugar Body Scrub \u2014 2oz',
    description: 'Treat your hands and body to the deep exfoliation they deserve with this clean, calming sugar scrub. Infused with CBD isolate and a rich blend of nourishing oils, it delivers a luxurious moisturizing experience \u2014 completely free of psychoactive effects.',
    benefits: [
      'Cane sugar exfoliation',
      'Lavender & Eucalyptus essential oils',
      'Nano CBD infused',
      'Real lavender flowers throughout'
    ],
    size: '2 oz',
    ingredients: 'Sugar, Grape Seed Oil, Olive Oil, Coconut Oil, Sunflower Oil, Lavender EO, Eucalyptus EO, Hemp Seed Oil, Nano CBD, Citric Acid, Vitamin E, Lavender Flowers.',
    howToUse: 'Massage onto damp skin in circular motions. Rinse and enjoy the calm.'
  },
  {
    id: 'strawberry-delight-sugar-body-scrub',
    title: 'Strawberry Delight Sugar Body Scrub',
    price: 13.99,
    compareAtPrice: 19.99,
    images: [
      '/images/products/strawberry-delight-sugar-body-scrub.jpg',
      '/images/products/scrub-how-to-use.png'
    ],
    category: 'Skincare',
    tags: ['Body Scrub', 'Nano CBD'],
    tagline: 'Nano CBD Sugar Body Scrub \u2014 2oz',
    description: 'Gently exfoliate and nourish with this calming sugar scrub, infused with hemp-derived CBD and botanical oils. Designed to soften skin and soothe the senses \u2014 THC-free and safe for daily self-care rituals.',
    benefits: [
      'Strawberry & chocolate blend',
      'Nano CBD infused',
      'Softens and hydrates skin',
      'Safe for daily use'
    ],
    size: '2 oz',
    ingredients: 'Sugar, Sunflower Oil, Coconut Oil, Grape Seed Oil, Olive Oil, Nano CBD, Citric Acid, Coconut Flakes, Hemp Seed Oil, Vitamin E, Strawberries, Chocolate.',
    howToUse: 'Massage onto damp skin in circular motions. Rinse and enjoy the sweetness.'
  },
  {
    id: 'soul-skin-starter-kit',
    title: 'Soul & Skin Starter Kit',
    price: 35.99,
    compareAtPrice: 45.00,
    images: [
      '/images/products/soul-skin-starter-kit.jpg',
      '/images/products/scrub-trio-benefits.png',
      '/images/products/scrub-how-to-use.png',
      '/images/products/compassion-pledge.png',
      '/images/products/self-love-calendar.png'
    ],
    category: 'Bundles',
    tags: ['Bundle', 'Skincare'],
    tagline: 'Body Scrub Trio Bundle \u2014 Nano CBD Infused (2oz each)',
    description: 'Indulge in our Sugar Body Scrub Trio infused with 125mg Nano CBD for a luxurious exfoliating and moisturizing experience. Featuring Lavender & Eucalyptus, Coconut & Vanilla, and Strawberry Delight scents to rejuvenate mind, body, and spirit.',
    benefits: [
      'Includes Lavender & Eucalyptus',
      'Includes Coconut & Vanilla',
      'Includes Strawberry Delight',
      '125mg Nano CBD total',
      '3 x 2oz jars'
    ],
    size: '3 x 2 oz jars',
    ingredients: 'See individual product ingredients.',
    howToUse: 'Gently massage a small amount onto damp skin in circular motions. Rinse thoroughly. Use 2\u20133 times a week to exfoliate, hydrate, and soothe.'
  },
  {
    id: 'compassion-care-pack',
    title: 'Compassion Care Pack',
    price: 55.00,
    compareAtPrice: 75.00,
    images: [
      '/images/products/compassion-care-pack.jpg',
      '/images/products/compassion-pledge.png',
      '/images/products/self-love-calendar.png'
    ],
    category: 'Bundles',
    tags: ['Bundle', 'Massage Oil'],
    tagline: 'Massage Oil Collection \u2014 3 x 2oz',
    description: 'Indulge in the ultimate self-care experience with our top-of-the-line Massage Oil Collection, crafted with luxurious carrier oils and potent essential oils for deep nourishment and therapeutic relief. Each blend features high-quality Nano CBD, cold-pressed botanicals, and aromatherapeutic essential oils designed to target specific needs.',
    benefits: [
      'Rejuvenate (2oz) \u2014 Orange, Eucalyptus, Peppermint, Tea Tree',
      'Relax (2oz) \u2014 Sandalwood, Frankincense, Marjoram, Ylang Ylang',
      'Therapeutic (2oz) \u2014 Lavender, Frankincense, Myrrh'
    ],
    size: '3 x 2 oz bottles',
    ingredients: 'See individual massage oil listings for full ingredients.',
    howToUse: 'Warm a small amount between palms and massage into skin as desired.'
  },
  {
    id: 'fireball-elixir',
    title: 'Fireball Elixir',
    price: 10.00,
    compareAtPrice: 14.99,
    images: [
      '/images/products/fireball-elixir.jpg',
      '/images/products/fireball-how-to-use.png'
    ],
    category: 'Elixirs',
    tags: ['Energy', 'Focus', 'CBD'],
    tagline: 'Natural energy, performance & focus (fast-acting)',
    description: 'Fireball Elixir is a potent blend of natural ingredients designed to boost energy, enhance immunity, and promote overall wellness \u2014 experience revitalizing benefits with every drop. Infused with nano CBD and adaptogenic herbs. No THC, no high \u2014 just grounded wellness.',
    benefits: [
      'Maca, Yohimbine, Guarana, Schisandra: stamina, blood flow, mental energy',
      'Ashwagandha, Rhodiola: balances stress and hormones',
      'CBD Isolate: helps ease performance anxiety',
      'Great for on-the-go focus, workouts, or intimacy support'
    ],
    size: '5ml \u2014 50mg CBD per bottle',
    ingredients: 'Honey, Nano CBD, Maca, Ashwagandha, Guarana Seed, Yohimbine, Schisandra, Rhodiola.',
    note: 'Please note that the travel sizes DO NOT have ingredient labels and the colors of the bottles may vary.',
    howToUse: 'Shake well. Place 1 dropper under the tongue for fast-acting focus and energy.'
  },
  {
    id: 'focus-capsules',
    title: 'Focus Capsules',
    price: 8.00,
    compareAtPrice: 14.99,
    images: [
      '/images/products/focus-capsules.jpg'
    ],
    category: 'Capsules',
    tags: ['Focus', 'Brain'],
    tagline: 'Brain Booster \u2014 10 ct',
    description: 'Enhance your cognitive performance with Focus Brain Booster. This powerful supplement supports mental clarity, concentration, and memory, empowering you to achieve your fullest potential.',
    benefits: [
      'Gotu Kola, Bacopa, Rhodiola, Rosemary: brain-boosting herbs',
      'Ashwagandha: reduces mental fatigue and anxiety',
      'CBD Isolate: helps with clarity and focus without jitters',
      '10mg CBD per capsule as an ingredient booster'
    ],
    size: '10 count',
    ingredients: 'CBD Isolate, Gotu Kola, Bacopa, Rosemary, Rhodiola, Ashwagandha, Cocoa Butter, Coconut Oil.',
    note: 'Due to inconsistent capsule availability from the international market, capsule colors may vary. Come in a Ziploc baggie and are NOT bottled.',
    howToUse: 'Take 1\u20132 capsules in the morning with water for mental clarity.'
  },
  {
    id: 'gift-of-compassion',
    title: 'Gift of Compassion',
    price: 45.00,
    compareAtPrice: 65.00,
    images: [
      '/images/products/focus-capsules.jpg',
      '/images/products/somnific-capsules.jpg',
      '/images/products/cherry-vanilla-lip-balm.jpg',
      '/images/products/a-okay-elixir.jpg',
      '/images/products/fireball-elixir.jpg',
      '/images/products/compassion-pledge.png',
      '/images/products/self-love-calendar.png'
    ],
    category: 'Bundles',
    tags: ['Bundle', 'Gift'],
    tagline: 'Boost focus, calm, sleep, and energy \u2014 naturally',
    description: 'Perfect for daily wellness support. Our Gift of Compassion bundle covers focus, sleep, calm and energy with our most-loved herbal essentials.',
    benefits: [
      'Focus Capsules (10 ct) \u2014 brain-boosting herbs + CBD isolate',
      'Somnific Capsules (10 ct) \u2014 deep restful sleep + muscle relaxation',
      'Cherry Vanilla Lip Balm (Tinted) \u2014 hydrating balm with sheer tint',
      'A-Okay Drops (5 ml) \u2014 fast-acting calm',
      'Fireball Elixir (5 ml) \u2014 natural energy, no crash'
    ],
    size: 'Bundle of 5 items',
    ingredients: 'See individual product listings.',
    note: 'Capsules come in a Ziploc baggie and are NOT bottled. Capsule colors may vary. 5ml travel sizes do not include ingredient labels; bottle colors may vary. 10 mg CBD per capsule.',
    howToUse: 'Use each product per the instructions on individual product pages.'
  },
  {
    id: 'herbs-we-love-gift-card',
    title: 'Herbs We Love Gift Card',
    price: 10.00,
    compareAtPrice: null,
    images: [
      '/images/products/herbs-we-love-gift-card.svg'
    ],
    category: 'Gift Cards',
    tags: ['Gift Card'],
    tagline: 'The gift of peace, plants, and presence',
    description: 'Wrap your love in herbal warmth. The Herbs We Love Electronic Gift Card is a thoughtful way to share comfort, healing, and joy \u2014 without the shipping stress. Let your loved ones choose from our handcrafted herbal remedies, CBD-infused wellness products, and soul-soothing self-care essentials. Delivered instantly by email, it\u2019s the perfect last-minute gift that still feels deeply personal.',
    benefits: [
      'Delivered instantly by email',
      'Choose your value: $10, $25, $50, $100',
      'Send to yourself or a loved one',
      'Redeemable on any Herbs We Love product'
    ],
    variants: [
      { id: '10', label: '$10', price: 10.00 },
      { id: '25', label: '$25', price: 25.00 },
      { id: '50', label: '$50', price: 50.00 },
      { id: '100', label: '$100', price: 100.00 }
    ],
    isGiftCard: true,
    ingredients: 'Digital delivery.',
    howToUse: 'Enter the code at checkout to redeem.'
  },
  {
    id: 'rejuvenating-massage-oil',
    title: 'Rejuvenating Massage Oil',
    price: 21.99,
    compareAtPrice: 27.99,
    images: [
      '/images/products/rejuvenating-massage-oil.jpg'
    ],
    category: 'Body Care',
    tags: ['Massage Oil', 'Nano CBD'],
    tagline: 'Invigorate the senses and restore vitality \u2014 2oz',
    description: 'Experience ultimate relaxation with our Rejuvenating Massage Oil. A refreshing, energizing blend infused with Orange, Eucalyptus, Peppermint, Tea Tree and nano CBD to awaken your senses, soothe tired muscles, revitalize the skin, and promote overall well-being. THC-free and full of renewal.',
    benefits: [
      'Boosts circulation and energy with peppermint & orange',
      'Relieves tension with CBD, eucalyptus, and myrrh',
      'Deep moisture from avocado, jojoba, and meadowfoam',
      'Perfect for morning routines & post-workout massages'
    ],
    size: '2 oz',
    ingredients: 'Sunflower Oil, MCT Oil, Apricot Kernel Oil, Avocado Oil, Jojoba Oil, Sesame Oil, Borage Oil, Meadowfoam Oil, Nano CBD, Orange EO, Frankincense EO, Eucalyptus EO, Peppermint EO, Bergamot EO, Tea Tree EO, Myrrh EO, Ylang Ylang EO.',
    note: 'Only includes one 2oz bottle. Pump is not included.',
    howToUse: 'Warm a small amount between palms and massage into skin in circular motions.'
  },
  {
    id: 'relax-massage-oil',
    title: 'Relax Massage Oil',
    price: 21.99,
    compareAtPrice: 27.99,
    images: [
      '/images/products/relax-massage-oil.jpg'
    ],
    category: 'Body Care',
    tags: ['Massage Oil', 'Calming'],
    tagline: 'Calm the body and mind \u2014 2oz',
    description: 'Discover tranquility with Relax Massage Oil, expertly formulated to soothe the body and mind. This premium blend of nourishing oils enhances relaxation and alleviates tension, making it perfect for therapeutic massages or self-care rituals. THC-free and crafted for serenity.',
    benefits: [
      'Deep relaxation with sandalwood, frankincense & lavender',
      'Vitamin E and MCT oil nourish skin',
      'CBD enhances calming effects',
      'Perfect for evening wind-down and anxiety relief'
    ],
    size: '2 oz',
    ingredients: 'MCT Oil, Sunflower Oil, Apricot Oil, Avocado Oil, Jojoba Oil, Meadowfoam Oil, Borage Oil, Nano CBD, Vitamin E, Frankincense EO, Sandalwood EO, Myrrh EO, Bergamot EO, Ylang Ylang EO, Benzoin EO, Marjoram EO.',
    note: 'Only includes one 2oz bottle. Pump is not included.',
    howToUse: 'Warm a small amount between palms and massage into skin in gentle strokes.'
  },
  {
    id: 'therapeutic-massage-oil',
    title: 'Therapeutic Massage Oil',
    price: 21.99,
    compareAtPrice: 27.99,
    images: [
      '/images/products/therapeutic-massage-oil.jpg'
    ],
    category: 'Body Care',
    tags: ['Massage Oil', 'Pain Relief'],
    tagline: 'Targeted relief for sore, tight or aching muscles \u2014 2oz',
    description: 'Experience relaxation with our Therapeutic Massage Oil, expertly formulated to soothe muscles, enhance circulation, and promote overall well-being for a rejuvenating experience. Ideal for professional therapists and at-home use for ultimate tranquility. No THC, just pure plant-powered relief.',
    benefits: [
      'Deep muscle penetration and anti-inflammatory relief',
      'CBD and myrrh help reduce pain and support recovery',
      'Lavender and frankincense promote calm and healing',
      'Perfect for sports recovery, injury relief, or focused therapy'
    ],
    size: '2 oz',
    ingredients: 'Sunflower Oil, MCT Oil, Apricot Kernel Oil, Avocado Oil, Jojoba Oil, Sesame Oil, Borage Oil, Meadowfoam Oil, Nano CBD, Frankincense EO, Myrrh EO, Lavender EO.',
    note: 'Only includes one 2oz bottle. Pump is not included.',
    howToUse: 'Warm a small amount between palms and massage into affected areas up to 3 times daily.'
  },
  {
    id: 'respiratory-support-elixir',
    title: 'Respiratory Support Elixir',
    price: 10.00,
    compareAtPrice: 15.99,
    images: [
      '/images/products/respiratory-support-elixir.jpg',
      '/images/products/respiratory-guide.png'
    ],
    category: 'Elixirs',
    tags: ['Respiratory', 'Immune'],
    tagline: 'Lung & Immune Health \u2014 5ml Travel Size',
    description: 'Nano CBD Wellness Drops for Respiratory & Immune Support. This compact formula is designed to support your body\u2019s natural defenses and respiratory clarity \u2014 perfect for travel, daily use, or seasonal wellness. Infused with Nano CBD for rapid absorption, this blend combines traditional herbs with modern ingredients to help you stay balanced wherever life takes you.',
    benefits: [
      '5ml travel size \u2014 easy to carry, easy to use',
      'Powered by Nano CBD for rapid delivery',
      'Honey, elderberry, NAC, mullein, plantain, peppermint & more',
      'Complements your immune and lung wellness routine'
    ],
    size: '5ml travel size',
    ingredients: 'Water, Honey, Glycerin, Elderberry, NAC, Mullein, Plantain, Peppermint Oil, Schisandra, Ginger, Natural Preservative, Nano CBD.',
    note: 'Travel-size bottles do not include ingredient labels. Bottle color may vary.',
    howToUse: 'Shake well. Take 1 dropper 2\u20133 times daily as needed.'
  },
  {
    id: 'sleep-syrup-w-cbn',
    title: 'Sleep Syrup W/ CBN',
    price: 10.00,
    compareAtPrice: 14.99,
    images: [
      '/images/products/sleep-syrup.jpg',
      '/images/products/sleep-syrup-ingredients.png',
      'https://www.herbswelove.com/cdn/shop/files/How_to_Use_Sleep_Syrup_with_CBN.png?v=1758436245&width=1200'
    ],
    category: 'Sleep',
    tags: ['Sleep', 'CBN', 'CBD'],
    tagline: 'Promotes deep, restful sleep with no grogginess',
    description: 'A gentle, plant-powered tonic infused with CBD isolate and adaptogenic herbs. Designed to support restful sleep with CBN, nano CBD, chamomile, passionflower, magnolia bark, and hops. No THC, no high \u2014 just grounded wellness.',
    benefits: [
      'CBD Isolate + CBN + Nano CBD: relaxes nervous system',
      'Valerian Root, Chamomile, Passion Flower: calms mind & body',
      'L-Tryptophan, Magnolia Bark, Hops: supports serotonin & mood',
      'MCT Oil, Glycerin, Honey Water: quick-absorbing, gentle on the stomach'
    ],
    variants: [
      { id: '5ml', label: '5ml \u2014 67mg CBD & 25mg CBN', price: 10.00 },
      { id: '30ml', label: '30ml \u2014 400mg CBD & 150mg CBN', price: 20.99 }
    ],
    ingredients: 'Glycerin, Honey Water, Lecithin, MCT Coconut Oil, Valerian Root, Hops, Chamomile, L-Tryptophan, Passion Flower, Magnolia Bark, Natural Flavor. Active: CBD Isolate, Nano CBD, CBN.',
    note: 'Please note that the 5ml travel sizes DO NOT have ingredient labels and the colors of the bottles may vary.',
    howToUse: 'Take 1 dropper 30 minutes before bed. Adjust as needed.'
  },
  {
    id: 'somnific-capsules',
    title: 'Somnific Capsules',
    price: 8.00,
    compareAtPrice: 14.99,
    images: [
      '/images/products/somnific-capsules.jpg',
      'https://www.herbswelove.com/cdn/shop/files/2F98681F-F784-45B4-A3F4-A1696E20031A.png?v=1767849534&width=1200'
    ],
    category: 'Capsules',
    tags: ['Sleep', 'Muscle Relaxant'],
    tagline: 'Sleep Aid / Muscle Relaxant \u2014 10 ct',
    description: 'Somnific Capsules promote restful sleep and relaxation, utilizing natural ingredients to support healthy sleep cycles. Experience rejuvenating rest and wake refreshed with this alternative health solution.',
    benefits: [
      'Nano CBD, Melatonin, GABA: calms nervous system',
      'Valerian, Reishi, Passion Flower: promotes relaxation',
      'Magnesium & Calcium Carbonate: eases tension, supports muscles',
      '10mg CBD per capsule as an ingredient booster'
    ],
    size: '10 count',
    ingredients: 'Magnesium Carbonate, Calcium Carbonate, Valerian, Passion Flower, Reishi, GABA, Nano CBD, Melatonin, Dicalcium Phosphate.',
    note: 'Due to inconsistent capsule availability, capsule colors may vary. Come in a Ziploc baggie and are NOT bottled.',
    howToUse: 'Take 1\u20132 capsules 30 minutes before bed with water.'
  }
];

export const categories = ['All', 'Elixirs', 'Skincare', 'Body Care', 'Capsules', 'Sleep', 'Pets', 'Bundles', 'Gift Cards'];

export const getProduct = (id) => products.find(p => p.id === id);
